export const EMPTY_COMPLEX_FORM_STATE = {
  name: "", city: "", cityCategory: "city", coordinates: [], presetBase: "",
  category: "residential", status: false, sipClients: [], developer: "",
  location: "", metro: "", working_hours: "", info: "", isApartments: false,
  completion_dates: [], finishes_available: [], prices: {},
};

const CLONEABLE_FIELDS = [
  "name", "city", "cityCategory", "coordinates", "presetBase", "category",
  "developer", "location", "metro", "working_hours", "info", "isApartments",
  "completion_dates", "finishes_available", "prices",
];

function deepCopy(value) {
  if (typeof structuredClone === "function") return structuredClone(value);
  return JSON.parse(JSON.stringify(value));
}

export function createEmptyComplexFormState() {
  return deepCopy(EMPTY_COMPLEX_FORM_STATE);
}

export function createCloneComplexFormState(sourceComplex) {
  const source = sourceComplex && typeof sourceComplex === "object" ? sourceComplex : {};
  const clone = createEmptyComplexFormState();
  for (const field of CLONEABLE_FIELDS) {
    if (typeof source[field] !== "undefined") clone[field] = deepCopy(source[field]);
  }
  clone.name = clone.name ? `${clone.name} copy` : "";
  clone.status = false;
  clone.sipClients = (Array.isArray(source.sipClients) ? source.sipClients : [])
    .filter((client) => client && typeof client === "object")
    .map(({ _id, ...client }) => ({ ...deepCopy(client), status: false }));
  return clone;
}
